module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.584a18d5.png";